import {FC, useEffect} from 'react';

const BodyNoScroll: FC<any> = ({isOpen, children}) => {
  useEffect(() => {
    if (!isOpen) return;
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100vh';

    return () => {
      document.body.style.overflow = 'auto';
      document.body.style.height = 'auto';
    };
  }, [isOpen]);

  return <div style={{display: isOpen ? 'flex' : 'none'}}>{children}</div>;
};

export default BodyNoScroll;
